import { type GetHookResponse } from '../hooks'
import { type RecordingRubricActiveSuccess, type RubricData, type RecordingRubricActiveInput } from '@terros/common'
import { useTantalimQuery } from '../query'
import { rubricActiveKey } from '../keys'

export const useActiveRubric = (): GetHookResponse<RubricData> => {
  return useTantalimQuery<RecordingRubricActiveInput, RecordingRubricActiveSuccess, RubricData>({
    url: '/recording/rubric/active',
    queryKey: rubricActiveKey(),
    input: {},
    convertResponse: (data) => data.rubric,
  })
}
